import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import FavoriteIcon from '@mui/icons-material/Favorite';
import { IconButton } from '@mui/material';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import { useEffect, useState } from 'react';
import { deleteObject, deletePublicObject, listObjectsAndUrls, listPublicObjectsAndUrls } from '../../data/aws/s3/UserBlobs';
import { ActionIcons } from '../../Iconography';
import { ComponentMode } from '../../types/AppTypes';
import FileSelectCard from './FileSelectCard';
const debug = process.env.REACT_APP_DEBUG && false;
export default function PhotosCard(props) {
    const { matchedPrimary, actions, transactionFunctions, userFunctions, searchParams, editMode } = props;
    debug && console.log('PhotosCard has props', props);
    const [objectCount, setObjectCount] = useState(0);
    const [objectsAndUrls, setObjectsAndUrls] = useState({});
    useEffect(() => {
        async function effectList() {
            const publicList = await listPublicObjectsAndUrls(props.matchedPrimary.sk);
            const privateList = await listObjectsAndUrls(props.matchedPrimary.sk);
            const list = Object.fromEntries([...Object.entries(publicList), ...Object.entries(privateList)]);
            setObjectsAndUrls(list);
            setObjectCount(Object.values(list).length);
        }
        effectList();
    }, [props.matchedPrimary.sk, objectCount]);
    debug && console.log('PhotosCard has saveObject', transactionFunctions?.saveObject);
    const saveImageAsDefault = (objectAndUrl) => {
        if (objectAndUrl.key === undefined)
            return;
        const clone = structuredClone(matchedPrimary);
        if (clone.primaryS3Image?.key === objectAndUrl.key) {
            debug && console.log('PhotosCard', 'Image was already default, removing...');
            clone.primaryS3Image.key = '';
            transactionFunctions.saveObject(clone);
            userFunctions.addObjectsToState([clone]);
        }
        else {
            debug && console.log('PhotosCard', 'Setting image as default...');
            clone.primaryS3Image = { key: objectAndUrl.key };
            transactionFunctions.saveObject(clone);
            userFunctions.addObjectsToState([clone]);
        }
    };
    const deleteImage = async (objectAndUrl) => {
        if (objectAndUrl.key === undefined)
            return;
        const clone = structuredClone(matchedPrimary);
        if (clone.primaryS3Image?.key === objectAndUrl.key) {
            clone.primaryS3Image.key = '';
            transactionFunctions.saveObject(clone);
            userFunctions.addObjectsToState([clone]);
        }
        const publicRes = await deletePublicObject(objectAndUrl.key);
        const privateRes = await deleteObject(objectAndUrl.key);
        if (publicRes.$metadata.httpStatusCode === 204 || privateRes.$metadata.httpStatusCode === 204)
            setObjectCount((oc) => oc - 1);
    };
    const parentHooks = {
        addKey: ({ key }) => {
            setObjectCount((oc) => oc + 1);
        },
    };
    return (_jsxs(_Fragment, { children: [_jsx(FileSelectCard, { matchedPrimary, userFunctions, transactionFunctions, searchParams, actions, parentHooks, editMode }), Object.values(objectsAndUrls).length > 0 && (_jsx(ImageList, { variant: "masonry", cols: 3, sx: { marginBlockStart: 1 }, children: Object.values(objectsAndUrls)
                    .filter((objectAndUrl) => typeof objectAndUrl.url === 'string' && typeof objectAndUrl.key === 'string')
                    .map((objectAndUrl) => (_jsxs(ImageListItem, { cols: 1, children: [_jsx("img", { src: objectAndUrl.url, alt: matchedPrimary.name, loading: "lazy" }), _jsx(ImageListItemBar, { actionIcon: _jsxs(_Fragment, { children: [_jsx(IconButton, { onClick: () => saveImageAsDefault(objectAndUrl), disabled: props.editMode !== ComponentMode.EDIT, children: _jsx(FavoriteIcon, { htmlColor: objectAndUrl.key === matchedPrimary.primaryS3Image?.key ? 'red' : 'lightgrey' }) }), _jsx(IconButton, { onClick: () => deleteImage(objectAndUrl), disabled: props.editMode !== ComponentMode.EDIT, children: _jsx(ActionIcons.Delete, { htmlColor: "lightgrey" }) })] }) })] }, objectAndUrl.key))) }))] }));
}
